<script>
    import {
        authoringToolsConfig,
        instructorExcludedTools,
        instructorExcludedSections,
        supportOnlyTools,
        PAGE_NEW,
        PAGE_CLONE,
        POST_NEW,
        BLOG_HOME,
        POST_CLONE
    } from "./authoringToolsConfig";

    import deepCopy from "deepcopy";

    const buildPremiumExcludedTools = () => {
        let excludedTools = [];
        // Remove pagebuilder/blog functionality
        if (typeof window.LWClient.pages_builder === "undefined" || !window.LWClient.pages_builder) {
            excludedTools.push(PAGE_CLONE);
            excludedTools.push(PAGE_NEW);
            excludedTools.push(POST_NEW);
            excludedTools.push(POST_CLONE);
            // excludedTools.push(BLOG_HOME);
        }

        return excludedTools;
    };

    export default {
        namespaced : true,
        state: {
            isSupport: window.me.email === 'info@learnworlds.com',
            isInstructor: window.me.isAInstructor,
            affiliateEnabled: window.SITE_AFFILIATES.active
        },
        getters: {
            config(state) {
                const config = authoringToolsConfig;

                if (state.isInstructor) {
                    config.course.excludedTools = [
                        ...config.course.excludedTools,
                        ...instructorExcludedTools,
                    ];
                    config.course.excludedSections = [
                        ...config.course.excludedSections,
                        ...instructorExcludedSections,
                    ];
                }

                return config;
            },

            context(state, getters, rootState) {
                return rootState.pages.pageContext.type;
            },

            currentConfig(state, getters) {
                return deepCopy(getters.config[getters.context]);
            },

            displayAuthoringTool (state, getters, rootState, rootGetters) {

                let excluded = getters.currentConfig.excludedTools;
                let premiumExcludedTools = buildPremiumExcludedTools();

                return (tool) => {
                    // Do not show blog settings if blog is not enabled
                    if (tool === 'blog_settings' && (!rootState.blogSettings || !rootState.blogSettings.enabled || state.isInstructor)) {
                        return false;
                    }

                    if (supportOnlyTools.includes(tool) && !state.isSupport) {
                        return false;
                    }

                    if (!getters.currentConfig) {
                        return false;
                    }


                    if (excluded.includes(tool)) {
                        return false;
                    }

                    if (premiumExcludedTools.includes(tool)) {
                        // We only want to show upgrade messages to author
                        if (!rootGetters['user/isAdmin']) {
                            return false;
                        }

                        return undefined;
                    }

                    return true;
                }
            },
            displaySection (state, getters) {
                return (section) => {
                    if (!getters.currentConfig) {
                        return false;
                    }

                    if (section === "Affiliates" && !state.affiliateEnabled) {
                        return false;
                    }

                    return getters.currentConfig.excludedSections.indexOf(section) === -1;
                }
            },

            getPreviewLink(state, getters) {
                return (slug) => {
                    if (!getters.currentConfig) {
                        return '';
                    }

                    return getters.currentConfig.previewLink.replace('{slug}', slug);
                }
            }
        },
        actions: {
            // Can be used with callbacks and promises
            triggerAuthoringTool ({dispatch, state, getters, rootState, rootGetters}, {tool, callback}) {
                return new Promise( (resolve, reject) => {
                    let premiumExcludedTools = buildPremiumExcludedTools();
                    let hasAccess = !premiumExcludedTools.includes(tool);

                    // If accessible then run callback if available and resolve for any pending actions
                    if (hasAccess) {
                        if (callback) {
                            callback();
                        }

                        resolve();
                        return;
                    }

                    if (rootGetters['user/isAdmin']) {
                        // Generic message for upgrade
                        window.showMessage("alert", "Feature Unavailable", "Unlock now by upgrading to a plan that supports this feature.", [
                            {
                                "name":"Upgrade",
                                "func":"authorController.redirectTo",
                                "args": ['/author/billing']
                            },
                            { "name": "OK" }
                        ]);
                    } else {
                        // Message to others
                        window.showMessage("alert", "Feature Unavailable", "It seems that you currently do not have access to this action.", [
                            { "name": "OK" }
                        ]);
                    }

                    reject();
                });
            },
        }
    }
</script>
